export default "__VITE_ASSET__cdc79b8d__"